import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Special event subscribe block',
  name: 'specialEventSubscribe',
  type: 'object',
  fields: [
    defineField({
      title: 'Show Countdown',
      name: 'showCountdown',
      type: 'boolean',
      initialValue: false,
    }),
    defineField({
      title: 'Theme',
      name: 'theme',
      type: 'string',
      options: {
        list: [
          { title: 'Default (red bg, white text)', value: 'default' },
          { title: 'Dark (dark bg, white text)', value: 'dark' },
          { title: 'Light (white bg, dark text)', value: 'light' },
        ],
      },
      initialValue: 'default',
      description: 'Background & text colors.',
    }),
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Content',
      name: 'content',
      type: 'text',
    }),
    defineField({
      title: 'Desktop BG',
      name: 'bgDesktop',
      type: 'image',
      options: {
        hotspot: true,
      },
    }),
    defineField({
      title: 'Mobile BG',
      name: 'bgMobile',
      type: 'image',
      options: {
        hotspot: true,
      },
    }),
    defineField({
      title: 'Desktop Background Video',
      name: 'bgVideoDesktop',
      type: 'mux.video',
      description:
        'Optional background video for desktop. When provided, replaces the desktop background image.',
    }),
    defineField({
      title: 'Mobile Background Video',
      name: 'bgVideoMobile',
      type: 'mux.video',
      description:
        'Optional background video for mobile. When provided, replaces the mobile background image.',
    }),
    defineField({
      title: 'Newsletter Box Title',
      name: 'newsletterBoxTitle',
      type: 'text',
    }),
    defineField({
      title: 'Mailing List Tag',
      name: 'tag',
      type: 'string',
    }),
    defineField({
      title: 'Mailing List Audience ID',
      name: 'audienceId',
      type: 'string',
    }),
  ],
  preview: {
    select: {
      title: 'title',
      media: 'bgDesktop',
    },
    prepare({ title, media }) {
      return {
        title: title || 'Special Event Subscribe',
        media,
        subtitle: 'Special Event Subscribe',
      }
    },
  },
})
